import { render, staticRenderFns } from "./DetailForSite.vue?vue&type=template&id=55e9a0da&scoped=true"
import script from "./DetailForSite.vue?vue&type=script&lang=js"
export * from "./DetailForSite.vue?vue&type=script&lang=js"
import style0 from "./DetailForSite.vue?vue&type=style&index=0&id=55e9a0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e9a0da",
  null
  
)

export default component.exports